import React from "react";
import { Link } from "react-router-dom";

export default function NotFoundPage() {
  return (
    <div className="mx-auto flex min-h-[60vh] max-w-4xl flex-col items-center justify-center px-6 text-center">
      <h1 className="text-5xl font-bold">404</h1>
      <p className="mt-4 text-slate-400">Page not found.</p>
      <Link
        to="/"
        className="mt-6 rounded-xl bg-cyan-500 px-5 py-3 font-semibold text-slate-950"
      >
        Go Home
      </Link>
    </div>
  );
}